import CompleteIntegrationCallRequestModelBase from '../_generated/modelBases/complete-integration-call-request-model-base';

export default class CompleteIntegrationCallRequestModel extends CompleteIntegrationCallRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
